import Spinner from 'react-bootstrap/Spinner';
import { useMemo, useRef, useState } from 'react';
import { AppHeader } from '../App/AppHeader';
import { AppFooter } from '../App/AppFooter';
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosErrorHandler, axiosGetWithHeader, axiosPutWithHeader, axiosResponseHandler, ShowAlertError } from '../Common/axios';
import Title, { Message, SingleButton } from '../Login/LoginUtil';
import { Input, Date, DateTime, Email, FirstNameLastName, LocationCoordinates, MaritalStatus, Mobile, Sex, SubmitResetClearButton, Timezone } from './ClientUtil';
import GLOBAL, { handleInput, handleReset } from '../Common/Util';
import { validateCity, validateDouble, validateEmail, validateFatherName, validateMobile, validateName } from './ClientValidate';

export function EditClient () {
    const {state} = useLocation();
    const runningId = state?state.runningId:null;
    const [spinner, setSpinner] = useState('Loading - Edit Client Page');
    const navigate = useNavigate();

    const [message, setMessage] = useState('');
    const [data, setData] = useState([]);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [fatherName, setFatherName] = useState('');
    const [sex, setSex] = useState('Male');
    const [birthDate, setBirthDate] = useState('');
    const [birthTime, setBirthTime] = useState('');
    const [birthTimezone, setBirthTimezone] = useState('5.5');
    const [birthCity, setBirthCity] = useState('');
    const [birthLongitude, setBirthLongitude] = useState('');
    const [birthLatitude, setBirthLatitude] = useState('');
    const [maritalStatus, setMaritalStatus] = useState('');
    const [marriageDate, setMarriageDate] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [success, setSuccess] = useState(false);
    const setMethod = { 
        setFirstName, setLastName, setFatherName, setSex, setBirthDate, setBirthTime, setBirthTimezone, setBirthCity,
        setBirthLongitude, setBirthLatitude, setMaritalStatus, setMarriageDate, setEmail, setMobile, setMessage };
    
    const firstNameReference = useRef();
    const lastNameReference = useRef();
    const fatherNameReference = useRef();
    const birthDateReference = useRef();
    const birthTimeReference = useRef();
    const marriageDateReference = useRef();
    const birthCityReference = useRef();
    const birthLongitudeReference = useRef();
    const birthLatitudeReference = useRef();
    const mobileReference = useRef();
    const emailReference = useRef();
    const [errorAlert, setErrorAlert] = useState(null);

    function init(runningId) {
        axiosGetWithHeader("/user/"+runningId,
            (response)=>{
              setData(response.data);
              assignDbData(response.data);
            },
            (error)=>{
              console.log(error);
            }
          );
    }

    useMemo(() => {
        axiosGetWithHeader("/user/"+runningId,
            (response)=>{
              setData(response.data);
              assignDbData(response.data);
              setSpinner(null);
            },
            (error)=>{
              console.log(error);
              setSpinner(null);
              setErrorAlert(error.message);
            }
          );
    }, [runningId]);

    function assignDbData(data){
        setFirstName(data.firstName);
        setLastName(data.lastName);
        setFatherName(data.fatherName);
        setSex(data.sex);
        setBirthDate((data.dobDate===null||data.dobDate===undefined)?"":data.dobDate);
        setBirthTime((data.dobTime===null||data.dobTime===undefined)?"":data.dobTime);
        setBirthTimezone((data.birthTimezone===null||data.birthTimezone===undefined)?"5.5":data.birthTimezone);
        setBirthCity(data.birthCity);
        setBirthLongitude(data.birthLongitude);
        setBirthLatitude(data.birthLatitude);
        setMaritalStatus(data.maritalStatus);
        setMarriageDate((data.marriageDate===null||data.marriageDate===undefined)?"":data.marriageDate.substring(0,10));
        setEmail(data.email);
        setMobile(data.mobile);
    }

    const handleBack = (event) => {
        setTimeout(() => {
          navigate('/kpastro.html', { state:{runningId:data.runningId}, replace: true });
          navigate(0);
        }, 100);
      }
    
    const handleSubmit =  (event) => {
        var msg = '';
        if(msg==='') msg = validateName(event, firstNameReference,firstName,lastNameReference, lastName);
        if(msg==='' && fatherName!==null && fatherName!=="") msg = validateFatherName(event,fatherNameReference,fatherName);
        if(msg==='' && mobile!==null && mobile!=="") msg = validateMobile(event,mobileReference,mobile);
        if(msg==='' && email!==null && email!=="") msg = validateEmail(event,emailReference,email);
        if(msg==='' && birthDate==="" ) {
            msg="Enter birth date";
            birthDateReference.current.focus();
        }
        if(msg==='' && birthTime==="" ) {
          msg="Enter birth time";
          birthTimeReference.current.focus();
        }
        if(msg==='') msg = validateCity(event,"birth place name",birthCityReference,birthCity);
        if(msg==='') msg = validateDouble(event,"latitude",birthLatitudeReference,birthLatitude,-90,90);
        if(msg==='') msg = validateDouble(event,"longitude",birthLongitudeReference,birthLongitude,-180,180);
        setMessage(msg); 
    
        if(msg==='') {
            const requestData = {
              id:data.id,
              mobile: mobile,
              email: email,
              firstName: firstName,
              lastName: lastName,
              fatherName: fatherName,
              sex: sex,
              birthDate: birthDate,
              birthTime: birthTime+(birthTime.length===5?":00":""),
              birthTimezone: birthTimezone,
              birthCity: birthCity,
              birthLongitude: birthLongitude,
              birthLatitude: birthLatitude,
              maritalStatus: maritalStatus,
              marriageDate: marriageDate,
              runningId:data.runningId
            }
            axiosPutWithHeader("/user/edit", requestData,
                (response)=>{
                    init(data.runningId);
                    setMessage(axiosResponseHandler(response, firstNameReference, ()=>customhandleReset(setMethod,firstNameReference), "Client details are updated successfully"));
                    GLOBAL.isLoading=false;
                    if(response.data.code==='200') {
                      setSuccess(true);
                    }
                },
                (error)=>{
                    setMessage(axiosErrorHandler(firstNameReference,error));
                    setErrorAlert(error.message);
                }
            );
        
        }      
        event.preventDefault();
    }

    const handleLocationInput = (name, value) => {
        switch(name) {
          case 'birthLongitude': setBirthLongitude(value); break;
          case 'birthLatitude': setBirthLatitude(value); break;
          default : 
        }
    }
    
    const customhandleReset = (setMethod,ref) =>{
        handleReset(setMethod,ref);
        setBirthTimezone('5.5');
        setMaritalStatus('');
    }  

    const handleDBDataReset =  (event) => {
        assignDbData(data);
        setMessage("");
        firstNameReference.current.focus();
    }

    return (
        <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppHeader/>
            </div>    
        </div> 
        <div class="m-0 p-0 row align-items-top homepageheight overflow-auto">
            <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    

            <div class="col-sm-12 col-md-8 m-0 p-2 bg-white text-black">
              <Title title="Edit Client" urlcallback={handleBack}></Title>
              <div class="row m-0 p-0 w-100 border rounded">
                <div class="col m-0 p-0 justify-content-center">
                <Message msg={message} />
                {success===false?
                <form method="post" onSubmit={handleSubmit}>
                  <div class="row m-0 p-0 w-100">
                  <div class="col-sm-12 col-lg-6">
                      <FirstNameLastName title="Name * " firstnamereference={firstNameReference} lastnamereference={lastNameReference} firstvalue={firstName} lastvalue={lastName} callback={(event)=>handleInput(event,setMethod)} />
                      <Input name="fatherName" title="Father Name" placeholder="Father Name" reference={fatherNameReference} data={fatherName} callback={(event)=>handleInput(event,setMethod)} />
                      <Mobile reference={mobileReference} data={mobile} callback={(event)=>handleInput(event,setMethod)} optional="true"/>
                      <Email reference={emailReference} data={email} callback={(event)=>handleInput(event,setMethod)} optional="true"/>
                      <MaritalStatus name="maritalStatus" title="Marital Status" data={maritalStatus} callback={(event)=>handleInput(event,setMethod)} />
                      <Date name="marriageDate" title="Marriage Date" reference={marriageDateReference} data={marriageDate} callback={(event)=>handleInput(event,setMethod)} />
                    </div>

                    <div class="col-sm-12 col-lg-6">
                      <Sex name="sex" title="Sex" data={sex} callback={(event)=>handleInput(event,setMethod)} />
                      <Timezone name="birthTimezone" data={birthTimezone} callback={(event)=>handleInput(event,setMethod)} />
                      <DateTime title1="Date of Birth * " title2="Time of Birth * " dateplaceholder="Birth Date" timeplaceholder="Birth Time" 
                        datename="birthDate" timename="birthTime" 
                        datereference={birthDateReference} timereference={birthTimeReference} 
                        datevalue={birthDate} timevalue={birthTime} callback={(event)=>handleInput(event,setMethod)} />
                      <LocationCoordinates 
                            cityname="birthCity" citytitle="Place of Birth * " cityreference={birthCityReference} cityvalue={birthCity}
                            coordinatesname="location" coordinatestitle="Location (Latitude, Longitude) * "
                            longitudename="birthLongitude" latitudename="birthLatitude" 
                            longitudereference={birthLongitudeReference} latitudereference={birthLatitudeReference} 
                            longitudevalue={birthLongitude} latitudevalue={birthLatitude} 
                            callback={(event)=>handleInput(event,setMethod)}  callbacklocation={handleLocationInput} />
                    </div>
                  </div>

                  <div class="card-body d-flex justify-content-center p-0 ">
                    <div class="w-50">
                      <SubmitResetClearButton callback={()=>customhandleReset(setMethod,firstNameReference)} callbackReset={handleDBDataReset} /> 
                    </div>
                  </div>  
                </form>
                :
                <div class="card-body d-flex justify-content-center p-0 pt-2 ">
                  <div class="w-50">
                    <SingleButton title="Ok" callback={handleBack}/>
                    </div>
                </div>  
                }
              </div>
            </div>
            </div>

            <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    

        </div>
        <div class="m-0 p-0 row noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppFooter/>
                <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
            </div>    
        </div> 
        </>
    );
}